import ProjectPage from './project/index'


const routes: IRoute[] = [
	{
		path: '/000201',
		component: ProjectPage,
		name: '项目管理',
	},
]

export default routes



// WEBPACK FOOTER //
// ./src/page/mdm/index.ts